import { selectIsActiveLiveChat } from 'reducers/workflows';
import { AgathaLoadingMessage } from './WorkflowsPage/WorkflowsPage';
import { useAppSelector } from 'hooks';
import LoadingDots from './LoadingDots';

export const LoadingMessageWithDots = () => {
  const isActiveLiveChat = useAppSelector(selectIsActiveLiveChat);

  return (
    <AgathaLoadingMessage
      hideBackground={true}
      isAuthorIconVisible
      isLiveChat={isActiveLiveChat}
      stepIndex={-1}
    >
      <LoadingDots />
    </AgathaLoadingMessage>
  );
};
